import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Login from './Login'
import { actions } from '../../store'

const mapStateToProps = state => ({
  organization: state.organization,
  user: state.user,
  auth: state.auth
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getOrganizationByName: actions.organization.getOrganizationByName,
  authorize: actions.auth.authorize,
  getUser: actions.user.getUser
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/views/Login/index.js